import { useEffect, useState } from "react";
import { getIssueClassificationById } from "../services/classificationService";

const useFetchIssueClassificationById = ({
  setIsLoading,
  currentClassificationId,
}: {
  setIsLoading?: (loading: boolean) => void;
  currentClassificationId?: string;
}) => {
  const [classificationData, setClassificationData] = useState<any>(null);

  useEffect(() => {
    const fetchClassification = async () => {
      if (!currentClassificationId) return;

      try {
        if (setIsLoading) setIsLoading(true);
        const result = await getIssueClassificationById(
          currentClassificationId
        );
        setClassificationData(result);
      } catch (error) {
        console.error("Error fetching classification by ID:", error);
        setClassificationData(null);
      } finally {
        if (setIsLoading) setIsLoading(false);
      }
    };

    fetchClassification();
  }, [currentClassificationId]);

  return [classificationData];
};

export default useFetchIssueClassificationById;
